// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2Bj0w","content":"LoadingAlert_content__2Fa4S"};